import { sendUpdateMessage } from '../../websocket';
function getDoorStatusValue(open) {
    return open ? 'DoorOpen' : 'AllDoorsClosedLocked';
}
export function doorStatusChange(open) {
    return function (dispatch, getState) {
        dispatch(sendUpdateMessage('door', {
            doorStatus: getDoorStatusValue(open),
            stopRequest: getState().stopRequest,
        }));
    };
}
export function stopRequestChange(stopRequest) {
    return function (dispatch, getState) {
        dispatch(sendUpdateMessage('door', {
            doorStatus: getDoorStatusValue(getState().doorStatus),
            stopRequest: stopRequest,
        }));
    };
}



//////////////////
// WEBPACK FOOTER
// ./src/components/DoorStatus/actions.ts
// module id = 1775
// module chunks = 0